/**
 * Helpers for championship capture-state (desired vs device-acked recording).
 */

export function normalizeCaptureTables(payload) {
  const tables = Array.isArray(payload?.tables) ? payload.tables : [];
  return tables
    .map((row) => ({
      capture_id: row?.capture_id || null,
      table_number: Number(row?.table_number),
      desired: Boolean(row?.desired),
      recording: Boolean(row?.recording),
      starting: Boolean(row?.starting),
      recording_count: Number(row?.recording_count) || 0,
      online_count: Number(row?.online_count) || 0,
      media_sync_at:
        row?.media_sync_at != null ? Number(row.media_sync_at) : null,
      cameras: Array.isArray(row?.cameras) ? row.cameras : [],
    }))
    .filter((row) => Number.isFinite(row.table_number) && row.table_number > 0);
}

/** Tables with at least one fresh device-acked recorder. */
export function recordingTablesFromCapture(payload) {
  if (Array.isArray(payload?.recording_tables)) {
    return payload.recording_tables
      .map(Number)
      .filter((n) => Number.isFinite(n) && n > 0);
  }
  return normalizeCaptureTables(payload)
    .filter((t) => t.recording)
    .map((t) => t.table_number);
}

/** Tables where staff asked for recording (may still be starting). */
export function desiredTablesFromCapture(payload) {
  if (Array.isArray(payload?.desired_tables)) {
    return payload.desired_tables
      .map(Number)
      .filter((n) => Number.isFinite(n) && n > 0);
  }
  return normalizeCaptureTables(payload)
    .filter((t) => t.desired)
    .map((t) => t.table_number);
}

export function tableCaptureStatus(payload, tableNumber) {
  const n = Number(tableNumber);
  const tables = normalizeCaptureTables(payload);
  return tables.find((t) => t.table_number === n) || null;
}

export function tableIsRecording(payload, tableNumber) {
  return Boolean(tableCaptureStatus(payload, tableNumber)?.recording);
}

export function tableIsDesired(payload, tableNumber) {
  return Boolean(tableCaptureStatus(payload, tableNumber)?.desired);
}

export function tableIsStarting(payload, tableNumber) {
  const row = tableCaptureStatus(payload, tableNumber);
  return Boolean(row?.desired && !row?.recording);
}
